module.exports = __webpack_public_path__ + "static/media/3_Ensure-Correct-Wall-Recess-Size-TooSmall.608c46e8.svg";